<template>
  <main class="main">
    <div class="hero-section-container">
      <img src="../images/Mask group.svg" class="img"/>
      <!-- также размытие снизу добавить -->
      <img src="../images/hero-blur.png" class="blur"/>
      <div class="section hero-section">
        <div class="wrapper">
          <div class="title large">
            {{ $t('Join the Unique') }}
          </div>
          <div class="title large">
            &nbsp; {{ $t('Adventure') }}
          </div>
          <div class="title big">{{ $t(`on rustcores.com Server!`) }}</div>
          <div class="ip-block">
            <div class="ip-block-wrapper">
              <div class="title start-playing-btn">{{ $t(`Start Playing Now!`) }}</div>
              <div class="title big ip-address">{{ ipAndPort }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section welcome-section">
      <div class="wrapper">
        <!-- Desktop version -->
        <div class="left desktop-only">
          <div class="title">{{ $t(`At RustCores`) }}</div>
          <div class="title">{{ $t(`In our shop`) }}</div>
        </div>
        <div class="right desktop-only">
          <div class="desc">
            {{ $t("you'll discover thrilling events, exclusive mods, and a friendly community. Our unique economic system and meticulously crafted gaming environment pro")}}
          </div>
          <div class="desc">
            {{ $t("you can use balance to purchase items that will help you stand out and enhance your character. All purchases are instantly delivered directly into")}} the game under your nickname!
          </div>
        </div>
        
        <!-- Mobile version -->
        <div class="mobile-blocks mobile-only">
          <div class="mobile-block">
            <div class="title">{{ $t(`At RustCores`) }}</div>
            <div class="desc">{{ $t(`you'll discover thrilling events, exclusive mods, and a friendly community. Our unique economic system and meticulously crafted gaming environment promise unforgettable adventures!`) }}</div>
          </div>
          <div class="mobile-block">
            <div class="title">{{ $t(`In our shop`) }}</div>
            <div class="desc">{{ $t(`you can use balance to purchase items that will help you stand out and enhance your character. All purchases are instantly delivered directly into the game under your nickname!`) }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="section features-section">
      <div class="wrapper">
        <div class="item">
          <div class="img-container">
            <div class="img-wrapper">
              <img src="../images/custom.png" class="img"/>
            </div>
          </div>
          <div class="text">
            <div class="title">{{ $t(`Custom`) }}</div>
            <div class="desc">{{ $t(`maps and missions`) }}</div>
          </div>
        </div>
        <div class="item">
          <div class="img-container">
            <div class="img-wrapper">
              <img src="../images/trophy.png" class="img"/>
            </div>
          </div>
          <div class="text">
            <div class="title">{{ $t(`Special`) }}</div>
            <div class="desc">{{ $t(`events and tournaments`) }}</div>
          </div>
        </div>
        <div class="item">
          <div class="img-container">
            <div class="img-wrapper">
              <img src="../images/uniqe.png" class="img"/>
            </div>
          </div>
          <div class="text">
            <div class="title">{{ $t(`Unique`) }}</div>
            <div class="desc">
              progression and reward<br>{{ $t(`systems`) }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="section steps-section" id="how">
      <div class="wrapper">
        <img src="../images/main_image_banner.png" class="bg"/>
        <div class="steps-block">
          <div class="title title-main">
            {{ $t("Steps on how to start playing on the server:")}}
          </div>
          <div class="item">
            <div class="img-container">
              <div class="img-wrapper">
                <div class="title">1.</div>
              </div>
            </div>
            <div class="text">
              <div class="desc">
                {{$t("Installing a legal copy of Rust is a must for accessing our gaming servER")}}
              </div>
            </div>
          </div>
          <div class="item">
            <div class="img-container">
              <div class="img-wrapper">
                <div class="title">2.</div>
              </div>
            </div>
            <div class="text">
              <div class="desc">
                Сopy the ip: {{ ipAndPort }}
              </div>
            </div>
          </div>
          <div class="item">
            <div class="img-container">
              <div class="img-wrapper">
                <div class="title">3.</div>
              </div>
            </div>
            <div class="text">
              <div class="desc">
                {{$t("And it's all! you can start playing, and if you want to purchase in-game items, you can visit our store")}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section general-info-section">
      <div class="wrapper">
        <div class="title big">{{$t("General")}}<br>{{$t('Information')}}</div>
        <div class="list">
          <div class="item">
            <div class="title">{{ $t(`Server Location`) }}</div>
            <div class="desc">
              {{$t("Hosted on high-performance servers to ensure minimal latency.")}}
            </div>
          </div>
          <div class="item">
            <div class="title">{{ $t(`Community Events`) }}</div>
            <div class="desc">
              {{$t("Weekly and monthly competitions with great prizes.")}}
            </div>
          </div>
          <div class="item">
            <div class="title">{{ $t(`Support`) }}</div>
            <div class="desc">
              {{$t("Dedicated support team to assist you with any issues.")}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section rules-section">
      <div class="wrapper">
        <div class="title big">{{$t("Brief Rules:")}}</div>
        <div class="list">
          <div class="item">
            <div class="img-container">
              <div class="img-wrapper">
              </div>
            </div>
            <div class="text">
              <div class="desc">
                {{$t("Respect all players and staff.")}}
              </div>
            </div>
          </div>
          <div class="item">
            <div class="img-container">
              <div class="img-wrapper">
              </div>
            </div>
            <div class="text">
              <div class="desc">
                {{$t("No cheating or exploiting game bugs.")}}
              </div>
            </div>
          </div>
          <div class="item">
            <div class="img-container">
              <div class="img-wrapper">
              </div>
            </div>
            <div class="text">
              <div class="desc">
                {{$t("Follow all community guidelines to ensure a fun and fair environment.")}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>

export default {
  name: 'Home',
  props: ['currency', 'currencyCode'],
  components: {
  },
  data: function() {
    return {
    }
  },
  computed: {
    ipAndPort() {
      return (this.$parent.ip && this.$parent.port) ? `${this.$parent.ip}:${this.$parent.port}` : '127.0.0.1:28015';
    },
  },
  mounted() {
    
  },
  methods: {
    
  }
}
</script>